"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandSettingChangeEvent = void 0;
var mobx_1 = require("mobx");
var lodash_1 = require("lodash");
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var DefaultColors_1 = __importStar(require("@CommonFrontendBackend/StyleServiceV2/Config/DefaultColors"));
var defaultFont_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/defaultFont");
var DefaultBrandColors_1 = __importDefault(require("@CommonFrontendBackend/Account/Brand/DefaultBrandColors"));
var axios_1 = __importDefault(require("axios"));
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var H1 = commonTypes_1.TextElementType.H1, H2 = commonTypes_1.TextElementType.H2, P = commonTypes_1.TextElementType.P;
var BrandSettingChangeEvent;
(function (BrandSettingChangeEvent) {
    BrandSettingChangeEvent["ColorsChange"] = "Account Brand Viewed";
    BrandSettingChangeEvent["FontsChange"] = "Account Fonts Changed";
})(BrandSettingChangeEvent = exports.BrandSettingChangeEvent || (exports.BrandSettingChangeEvent = {}));
var BrandStore = (function () {
    function BrandStore(account, modal, telemetry, apiBaseUrl, usingFeature, styleWorker) {
        var _a;
        var _this = this;
        this.modal = modal;
        this.apiBaseUrl = apiBaseUrl;
        this.styleWorker = styleWorker;
        this.colors = [];
        this.fonts = (_a = {},
            _a[H1] = defaultFont_1.defaultFont,
            _a[H2] = defaultFont_1.defaultFont,
            _a[P] = defaultFont_1.defaultFont,
            _a);
        this.useSameFont = false;
        this.minNumberOfColors = 2;
        this.deleteColor = function (index, shouldConfirm) {
            if (shouldConfirm === void 0) { shouldConfirm = true; }
            return __awaiter(_this, void 0, Promise, function () {
                var canDeleteColor, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = !shouldConfirm;
                            if (_a) return [3, 2];
                            return [4, this.confirmDeleteColor()];
                        case 1:
                            _a = (_b.sent());
                            _b.label = 2;
                        case 2:
                            canDeleteColor = _a;
                            if (canDeleteColor) {
                                this.colors.splice(index, 1);
                            }
                            return [2];
                    }
                });
            });
        };
        this.updateColor = function (newColor, index, shouldConfirm) {
            if (shouldConfirm === void 0) { shouldConfirm = true; }
            return __awaiter(_this, void 0, Promise, function () {
                var canUpdateColor, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = !shouldConfirm;
                            if (_a) return [3, 2];
                            return [4, this.confirmUpdateColor()];
                        case 1:
                            _a = (_b.sent());
                            _b.label = 2;
                        case 2:
                            canUpdateColor = _a;
                            if (canUpdateColor) {
                                this.colors[index] = (0, ColorUtils_1.getHex)(newColor);
                            }
                            return [2];
                    }
                });
            });
        };
        this.setGuessedColors = function (url) { return __awaiter(_this, void 0, void 0, function () {
            var response, guessedColors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, axios_1.default.get("".concat(this.apiBaseUrl, "/brand/colors/").concat(encodeURIComponent(url)), {
                            withCredentials: true,
                        })];
                    case 1:
                        response = _a.sent();
                        guessedColors = response.data.message;
                        if (guessedColors && guessedColors.length >= this.minNumberOfColors) {
                            this.colors = guessedColors;
                        }
                        return [2];
                }
            });
        }); };
        this.saveBrandSettingUpdate = function (updateBy) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sendBrandChangeTelemetry();
                        this.account.settings.brand.updateAt = new Date().toString();
                        this.account.settings.brand.updateBy = updateBy;
                        this.account.settings.brand.colors = this.copyColors();
                        this.account.settings.brand.fonts = this.copyFonts();
                        this.refreshColors();
                        return [4, this.styleWorker.modify(this.copyColors())];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        this.sendBrandChangeTelemetry = function () {
            _this.sendColorsChangeTelemetry();
            _this.sendFontsChangeTelemetry();
        };
        this.assembleColorsFromAccount = function (account) {
            var _a = account.settings.brand.colors, brand = _a.brand, complementary = _a.complementary, extra = _a.extra;
            if (extra.length === 0) {
                return [brand, complementary];
            }
            return __spreadArray([brand, complementary], __read(extra), false);
        };
        this.assembleFontsFromAccount = function (account) {
            var _a;
            var fonts = account.settings.brand.fonts;
            return _a = {},
                _a[H1] = fonts && fonts[H1] ? __assign({}, fonts[H1]) : defaultFont_1.defaultFont,
                _a[H2] = fonts && fonts[H2] ? __assign({}, fonts[H2]) : defaultFont_1.defaultFont,
                _a[P] = fonts && fonts[P] ? __assign({}, fonts[P]) : defaultFont_1.defaultFont,
                _a;
        };
        this.copyColors = function () {
            return {
                brand: _this.colors.length >= 1 ? _this.colors[0] : DefaultBrandColors_1.default.brand,
                complementary: _this.colors.length >= 2 ? _this.colors[1] : DefaultBrandColors_1.default.complementary,
                extra: _this.colors.length >= 3 ? _this.colors.slice(2, _this.colors.length) : (0, lodash_1.cloneDeep)(DefaultBrandColors_1.default.extra),
            };
        };
        this.copyFonts = function () {
            var _a;
            return _a = {},
                _a[H1] = __assign({}, _this.fonts[H1]),
                _a[H2] = __assign({}, _this.fonts[H2]),
                _a[P] = __assign({}, _this.fonts[P]),
                _a;
        };
        this.account = account;
        this.colors = this.assembleColorsFromAccount(account);
        this.fonts = this.assembleFontsFromAccount(account);
        this.telemetry = telemetry;
        this.usingBrandGuessor = usingFeature(FeatureFlag_1.FeatureFlag.BrandGuessor);
    }
    BrandStore.prototype.addColor = function (color) {
        this.colors.push((0, ColorUtils_1.getHex)(color));
    };
    BrandStore.prototype.refreshColors = function () {
        this.colors = this.assembleColorsFromAccount(this.account);
    };
    BrandStore.prototype.refreshFonts = function () {
        this.fonts = this.assembleFontsFromAccount(this.account);
    };
    BrandStore.prototype.revertChanges = function () {
        this.refreshColors();
        this.refreshFonts();
    };
    BrandStore.prototype.updateFont = function (elemType, font) {
        if (this.useSameFont) {
            this.fonts[H1] = __assign({}, font);
            this.fonts[H2] = __assign({}, font);
            this.fonts[P] = __assign({}, font);
        }
        else if ((0, commonTypes_1.isFontTextElementType)(elemType)) {
            this.fonts[elemType] = __assign({}, font);
        }
    };
    BrandStore.prototype.updateFonts = function (fonts) {
        this.useSameFont = false;
        this.updateFont(H1, fonts[H1]);
        this.updateFont(H2, fonts[H2]);
        this.updateFont(P, fonts[P]);
    };
    BrandStore.prototype.toggleSameFont = function () {
        this.useSameFont = !this.useSameFont;
        if (this.useSameFont) {
            this.updateFont(H2, this.fonts[H1]);
            this.updateFont(P, this.fonts[H1]);
        }
        else {
            this.refreshFonts();
        }
    };
    Object.defineProperty(BrandStore.prototype, "colorsWithThemeIndex", {
        get: function () {
            return __spreadArray(__spreadArray([], __read(this.colors.map(function (color, index) {
                return {
                    value: (0, ColorUtils_1.getRgba)(color),
                    themeIndex: index,
                };
            })), false), __read(DefaultColors_1.default), false);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandStore.prototype, "hasChanges", {
        get: function () {
            return !(0, lodash_1.isEqual)(this.account.settings.brand.colors, this.copyColors()) || this.hasFontsChanged();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandStore.prototype, "allColors", {
        get: function () {
            return __spreadArray(__spreadArray([], __read(this.colors), false), __read(DefaultColors_1.allDefaultColors.map(function (color) {
                return color.value;
            })), false);
        },
        enumerable: false,
        configurable: true
    });
    BrandStore.prototype.confirmDeleteColor = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.modal.showDeleteModal({
                            title: "Delete this color",
                            explainer: "You won’t be able to use this color in any new pages going forward, but it will remain in any existing pages.",
                            confirmLabel: "Delete color",
                        })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    BrandStore.prototype.confirmUpdateColor = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.modal.showConfirmModal({
                            title: "Update this color?",
                            explainer: "You'll be changing any existing pages where this color is currently being used. They will be updated to the new color you've selected.",
                            confirmLabel: "Update color",
                        })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    BrandStore.prototype.sendColorsChangeTelemetry = function () {
        if (this.assembleColorsFromAccount(this.account).length !== this.colors.length) {
            this.telemetry.track(BrandSettingChangeEvent.ColorsChange, {
                account_colors_number: this.colors.length,
            });
        }
    };
    BrandStore.prototype.sendFontsChangeTelemetry = function () {
        if (this.hasFontsChanged()) {
            this.telemetry.track(BrandSettingChangeEvent.FontsChange, {
                font_selected_h1: this.fonts[H1].name,
                font_selected_h2: this.fonts[H2].name,
                font_selected_p: this.fonts[P].name,
                font_source: "".concat(this.fonts[H1].vendor, ",").concat(this.fonts[H2].vendor, ",").concat(this.fonts[P].vendor),
            });
        }
    };
    BrandStore.prototype.hasFontsChanged = function () {
        return !(0, lodash_1.isEqual)(this.account.settings.brand.fonts, this.copyFonts());
    };
    var _a, _b, _c;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], BrandStore.prototype, "colors", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BrandStore.prototype, "fonts", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BrandStore.prototype, "useSameFont", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], BrandStore.prototype, "addColor", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BrandStore.prototype, "deleteColor", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], BrandStore.prototype, "updateColor", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], BrandStore.prototype, "setGuessedColors", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BrandStore.prototype, "refreshColors", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BrandStore.prototype, "refreshFonts", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BrandStore.prototype, "revertChanges", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof commonTypes_1.TextElementType !== "undefined" && commonTypes_1.TextElementType) === "function" ? _a : Object, typeof (_b = typeof commonTypes_1.IFont !== "undefined" && commonTypes_1.IFont) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], BrandStore.prototype, "updateFont", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof commonTypes_1.ITextFonts !== "undefined" && commonTypes_1.ITextFonts) === "function" ? _c : Object]),
        __metadata("design:returntype", void 0)
    ], BrandStore.prototype, "updateFonts", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BrandStore.prototype, "toggleSameFont", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], BrandStore.prototype, "colorsWithThemeIndex", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], BrandStore.prototype, "hasChanges", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], BrandStore.prototype, "allColors", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], BrandStore.prototype, "saveBrandSettingUpdate", void 0);
    return BrandStore;
}());
exports.default = BrandStore;
